<template>
  <div class="exp-status">
    <div class="module">
      <div class="module-title">
        <img :src="serverURL + 'images/node.png'" alt="" />
        {{ $t('lang.external.fzsy.content.home.使用情况') }}
      </div>
      <div class="module-content">
        <div class="module-content-item people">
          <p class="title">
            {{ $t('lang.external.fzsy.content.home.实验人数') }}
          </p>
          <p class="value">{{ data.userNumber }}</p>
        </div>
        <div class="module-content-item num">
          <p class="title">
            {{ $t('lang.external.fzsy.content.home.实验次数') }}
          </p>
          <p class="value">{{ data.expNum }}</p>
        </div>
      </div>
    </div>
    <div class="module">
      <div class="module-title">
        <img :src="serverURL + 'images/node.png'" alt="" />
        {{ $t('lang.external.fzsy.content.home.实验评价') }}
      </div>
      <div class="module-content score">
        <h1>{{ data.score }}</h1>
        <div class="score-info">
          <p>
            {{ data.scoreNum + $t('lang.external.fzsy.content.home.人评分') }}
          </p>
          <el-rate
            :allow-half="true"
            :value="rateValue"
            :colors="['#A63528', '#A63528', '#A63528']"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'exp-status',
  components: {},
  props: ['data'],
  data() {
    return {}
  },
  watch: {},
  computed: {
    rateValue() {
      return parseFloat(this.data.score)
    },
    serverURL() {
      return this.publicData.serverUrl
    },
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.exp-status {
  width: 100%;
  height: 100%;
  .module {
    width: 100%;
    background: #edf2f6;
    border-radius: 5px;
    margin-bottom: 15px;
    &-title {
      display: flex;
      align-items: center;
      color: #0c5893;
      padding: 20px;
      border-bottom: 1px solid #ccd4da;
      img {
        height: 16px;
        margin: 10px;
      }
    }
    &-content {
      padding: 20px;
      &-item {
        background-size: 100% 100%;
        color: white;
        position: relative;
        text-align: center;
        p {
          margin: 0;
        }
        .title {
          position: absolute;
          left: 20%;
          font-size: 16px;
          color: #666666;
        }
        .value {
          font-size: 30px;
          line-height: 2;
          padding: 15px 0 0 0;
        }
      }
      .people {
        background-image: var(--people-bg);
        margin-bottom: 15px;
      }
      .num {
        background-image: var(--num-bg);
      }
    }
    .score {
      padding: 40px;
      h1 {
        color: #a63528;
        margin: 0 10px 0 0;
      }
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;
      &-info {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        p {
          margin: 0;
          color: #666666;
          font-size: 13.5px;
        }
      }
    }
  }
}
</style>